import React, { useState } from "react";
import send_message_btn from "../../resources/images/sendMessageButton.svg";
import * as webRTCHandler from "../../utils/webRTCHandler";

const NewMessage = () => {
  const [message, setMessage] = useState("");

  const handleTextChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyPressed = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      //send Message to other Users
      sendMessage();
    }
  };

  const sendMessage = () => {
    if (message.trim().length > 0) {
      webRTCHandler.sendMessageUsingDataChannel(message);
      setMessage("");
    }
  };

  return (
    <div className="new_message_container" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", boxSizing: "border-box", overflow: "hidden" }}>
      <input
        className="new_message_input"
        style={{ flex: 1, minWidth: 0, fontSize: "16px" }}
        value={message}
        onChange={handleTextChange}
        placeholder="Type your message..."
        onKeyDown={handleKeyPressed}
      />
      <img
        className="new_message_button"
        style={{ flexShrink: 0 }}
        src={send_message_btn}
        alt="Send Message"
        onClick={sendMessage}
      />
    </div>
  );
};

export default NewMessage;